import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import moment from "moment-timezone";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {KeyboardDateTimePicker} from "@material-ui/pickers";
import {themeTypeToBool} from '../../../../../../../utils/helpers';
import t from "../../../../../../../languages/pl";
import {displayDateTimeFormat, dateTimePickerFormat} from '../../../../../../../utils/staticData';
import {compose} from "recompose";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import ActionCreator from '../../../../../../../store/actions/index';

const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        paddingBottom: theme.spacing(1),
        alignItems: "center",
        justifyContent: "flex-start"
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        width: 225
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    formsContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start"
    },
    inputField: {
        margin: theme.spacing(1),
        width: 225
    },
    label: {
        color: themeTypeToBool(theme.palette.type) ? "#9E9E9E" : "#FAFAFA",
    }
});

const InputField = withStyles(theme => ({
        root: {
            margin: theme.spacing(1),
            width: 225
        }
    }), {withTheme: true}
)(props => <TextField
    InputLabelProps={{
        style: {color: themeTypeToBool(props.theme.palette.type) ? "#9E9E9E" : "#FAFAFA"}
    }}
    {...props} />);

const PoolForm = props => {
    const {classes, isEdit, pool, availableDrivers, checkPoolValidation} = props;
    const [state, setState] = useState(pool);

    useEffect(() => {
        if (!pool)
            return;
        if (isEdit) {
            setState(pool);
        } else {
            setState(initialState);
        }
        checkPoolValidation();
    }, [pool]);

    const handlePoolChange = e => {
        e.persist();
        pool[e.target.name] = e.target.value;

        setState(prevState => ({
            ...prevState,
            [e.target.name]: e.target.value
        }));
    };

    const handlePoolDateChange = (propertyName, date) => {
        pool[propertyName] = moment(date).unix();

        setState(prevState => ({
            ...prevState,
            [propertyName]: moment(date).unix()
        }));
        checkPoolValidation();
    };

    const handleDriverChange = (driver) => {
        if (driver) {
            pool.kierowca_nazwa = driver.kierowca_nazwa;
            pool.kierowca_id = driver.kierowca_id;
            setState(prevState => ({
                ...prevState,
                kierowca_nazwa: driver.kierowca_nazwa,
                kierowca_id: driver.kierowca_id
            }));
        } else {
            pool.kierowca_nazwa = "";
            pool.kierowca_id = 0;
            setState(prevState => ({
                ...prevState,
                kierowca_nazwa: "",
                kierowca_id: 0
            }));
        }
        checkPoolValidation();
    };

    return (
        <React.Fragment>
            <form className={classes.container}>
                <KeyboardDateTimePicker
                    className={classes.inputField}
                    ampm={false}
                    variant="inline"
                    name="data_od"
                    value={state.data_od === 0 ? null : moment.unix(state.data_od).format(dateTimePickerFormat)}
                    // maxDate={moment.unix(state.data_do).format(dateTimePickerFormat)}
                    // maxDateMessage={t.maxDateMessage}
                    invalidDateMessage={t.invalidDateFormat}
                    onChange={(date) => handlePoolDateChange('data_od', date)}
                    label={t.from}
                    format={displayDateTimeFormat}
                />
                <KeyboardDateTimePicker
                    className={classes.inputField}
                    ampm={false}
                    variant="inline"
                    name="data_do"
                    value={state.data_do === 0 ? null : moment.unix(state.data_do).format(dateTimePickerFormat)}
                    minDate={moment.unix(state.data_od).format(dateTimePickerFormat)}
                    minDateMessage={t.minDateMessage}
                    invalidDateMessage={t.invalidDateFormat}
                    disabled={state.data_od === 0}
                    onChange={(date) => handlePoolDateChange('data_do', date)}
                    label={t.to}
                    format={displayDateTimeFormat}
                />
            </form>
            <h3>Kierowca</h3>
            <form className={classes.container}>
                <Autocomplete
                    value={state}
                    noOptionsText={t.noDrivers}
                    classes={{inputRoot: classes.inputField}}
                    options={availableDrivers}
                    onChange={(event, value) => handleDriverChange(value)}
                    getOptionLabel={option => option.kierowca_nazwa}
                    renderInput={params =>
                        <TextField {...params}
                                   label={t.selectDriver}
                                   InputLabelProps={{
                                       classes: {root: classes.label},
                                       style: {marginLeft: 8}
                                   }}
                        />}
                />
            </form>
            <h3>Dane podróży</h3>
            <form className={classes.container}>
                <InputField
                    onChange={handlePoolChange}
                    label={t.targetPlace}
                    type="text"
                    name="cel_podrozy"
                    value={state.cel_podrozy}
                />
                {isEdit ?
                    <React.Fragment>
                        <InputField
                            label={t.started}
                            className={classes.textField}
                            value={state.rozpoczal}
                            onChange={handlePoolChange}
                            name="rozpoczal"
                            disabled
                        />
                        <InputField
                            label={t.finished}
                            className={classes.textField}
                            value={state.zakonczyl}
                            onChange={handlePoolChange}
                            name="zakonczyl"
                            disabled
                        />
                    </React.Fragment>
                    : null
                }
            </form>
        </React.Fragment>
    );
};

PoolForm.propTypes = {
    classes: PropTypes.object,
    pool: PropTypes.object,
    isEdit: PropTypes.bool,
    clients: PropTypes.array,
    checkPoolValidation: PropTypes.func,
    //redux
    availableDrivers: PropTypes.array,
};

const mapStateToProps = (state) => ({
    availableDrivers: state.driverReducer.availableDrivers
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};


export default compose(
    withStyles(styles),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(PoolForm);


const initialState = {
    cel_podrozy: "",
    data_do: 0,
    data_od: 0,
    kierowca_id: 0,
    kierowca_nazwa: "",
    rozpoczal: "",
    wynajem_id: 0,
    zakonczyl: ""
};
